import { en } from "vuetify/src/locale";

export default {
  ...en,

  home: "Home",
  mainTitle: "Julien SUTTER's resume",
  myNameIs: "Hello, my name is Julien and I am a",
  iAm: "Full Stack Software Engineer",
  downloadCv: "Download CV",
  frenchCv: "French CV",
  englishCv: "English CV",
  fullStack: {
    frontend: "Frontend",
    backend: "Backend",
    database: "Database",
    english: "English",
    description: {
      business:
        "I have been in the business for 10 years now and have discovered many languages and frameworks (Java, Hibernate, Spring, Typescript, VueJS, NestJS, Oracle, mongoDB, Couchbase...).",
      today:
        "Today, I define myself as a Full Stack developer, able to alternate between fontend, backend and database. I was also able to improve the quality of the code with the principles of clean code and TDD. I was also able to familiarise myself with the DevOps approach and microservices.",
      agile: {
        main:
          "Since the beginning of my career, I have always worked in Agile (Scrum only) and I am therefore steeped in the Agile culture:",
        1: "Focus on exchange and collaboration",
        2: "Focus on the quality of the software development",
        3: "Working together with end users to test, improve and correct",
        4: "Planning for change"
      },
      ux:
        "I am also very interested in the field of UX (User Experience) with the application of methods such as 6to1, the HORSE method, user interviews, prototyping...",
      anglais:
        "Working with collaborators in Portugal, I'm also used to working in English on my projects."
    }
  },
  footer: "This website has been developed in VueJS with the Vuetify librairy",
  waitingMobile:
    "The mobile version will arrive soon. For now, it is best to use the desktop version.",
  theme: {
    light: "Light theme",
    dark: "Dark theme"
  },
  experiences: {
    title: "Experiences",
    previous: "Older experience",
    next: "Newer experience",
    softway: {
      dates: "(March 2018 - Today)",
      disrupthor:
        "Personal project for Softway: creation of a tool to count disruptions during a sprint and transcribe them to save them in our project management tool. This makes it easy to see which teams have the most disruptions.",
      planningpoker:
        "Personal project for Softway: creation of a planning poker tool following the COVID crisis, instead of using online solutions. This project allowed me to do technology watch and to put WebSockets into practice.",
      dexther:
        "Implementation of a new medication database within the software. The software could already use two different drug databases depending on the affinity of the client with one or the other.",
      pmm:
        "Participation in the development of a new multi-modal prescription module (drug, care, biology and procedure in one go). This module was long awaited by the customers. At the beginning, we collaborated with the UX team to propose the best possible design. This project then continued as an extended team with Portuguese providers. I then switched to a Scrum Master role in addition to my developer role. All the communication of the team is now in english.",
      injectable:
        "Participation in the development of new functionalities for the prescription part of the software (new injectable module, printing of discharge prescription...).",
      offline:
        "Project for a backup solution to access different patient information even in case of a network outage with the data center. This solution allows to replace the printing of PDF document."
    },
    thales: {
      dates: "(September 2012 - March 2018)",
      edf: {
        title: "EDF (July 2017 - March 2018)",
        description:
          'Participation in the implementation of a common base with frontend in Angular 4 / TS + Cordova and backend in Java. Participation in the development of "white applications" serving as a development base for EDF project teams.'
      },
      boiron: {
        title: "Boiron (December 2015 - July 2017)",
        description:
          "Participation in the development of various management applications of the Boiron IS. Most of the applications are thick clients with a Swing front-end and a Java JEE back-end. Some applications in AngularJS technology. The applications are varied: orders, warehouses, prices, customers..."
      },
      biomerieux: {
        title: "Biomérieux (March 2015 - December 2015)",
        description:
          "Participation in the development of the various components of the V6 version of Myla in Java JEE, REST and GWT. Myla is an IT solution that allows to connect different analysis instruments to the Laboratory Information System (LIS)."
      },
      sncf: {
        title: "SNCF (May 2014 - March 2015)",
        description:
          "Parameterization and development of new business objects within the EBX5 software package for the MDM SIRH project, writing technical specifications from the generic specifications provided by the MOA. Technical administrator of the solution for SNCF."
      },
      orange: {
        title: "Orange (September 2012 - May 2014)",
        description:
          "Participation in the development of functionalities on an order tracking application. The order tracking is available to the customer from a web GUI; it is done by sending SMS and MAILS that inform the customer of the evolution of his order. Thanks to the Order Tracking Advisor GUI, the advisor can also inform the customer about the progress of his order (progress, expected delivery date...)."
      }
    }
  },
  formation: {
    title: "Training",
    master: {
      title:
        "Engineering degree - Computer Science and Communication Networks (2009 - 2012)",
      school: "Superior School of Physical and Electronic Chemistry of Lyon",
      sandwichCourse: "Work-study program at Orange",
      thirdYear: {
        title: "3th year project",
        description:
          "Study project for the implementation of a Web GUI testing framework for an order consultation site:",
        details: {
          "1": "Study of market solutions",
          "2":
            "Creation of a short list of suitable solutions (2 solutions retained: Selenium and QTP from HP)",
          "3": "POC of each solution",
          "4": "Presentation of solutions to the team",
          "5":
            "Implementation of the skeleton for the industrialization of the chosen solution: Selenium",
          "6": "Team support"
        }
      },
      secondYear: {
        title: "2nd year project",
        description:
          "Participation in the redesign of the GUI of the web application for order tracking (switch from JSP pages to the new Wicket framework):",
        details: {
          "1": "Competence building on the framework (POC and training)",
          "2":
            "Migration to the new framework of the different components of the application in a reduced team",
          "3":
            "Support to the rest of the team to understand the new framework",
          "4":
            "Participation in other developments of the application in SCRUM mode"
        }
      }
    },
    technicalDegree: {
      title: "Technical degree in Computer Science (2007 - 2009)",
      school: "University Institute of Technology 2 of Grenoble"
    },
    highSchool: {
      title: "Scientific bachelor degree, Mathematics option (2004 - 2007)",
      school: "Camille Sée High School of Colmar"
    }
  },
  competences: {
    title: "Skills",
    technicalSkills: "Technical skills",
    otherSkills: "Other skills"
  },
  hobbies: {
    title: "Hobbies",
    photography: "Photography",
    sports: "Sports",
    bouldering: "Bouldering",
    tennis: "Tennis",
    padel: "Padel",
    squash: "Squash",
    badminton: "Badminton",
    foot: "Football",
    running: "Running",
    swim: "Swimming",
    ultimate: "Ultimate frisbee"
  },
  details: {
    vuejs: "VueJS",
    nestjs: "NestJS",
    websockets: "WebSockets",
    openshift: "Openshift",
    java: "Java",
    jsp: "JSP",
    angularjs: "AngularJS",
    maven: "Maven",
    spring: "Spring",
    hibernate: "Hibernate",
    oracle: "Oracle",
    quarkus: "Quarkus",
    scrummaster: "Scrum Master",
    english: "English",
    mongodb: "MongoDB",
    typescript: "TypeScript",
    ux: "UX",
    ds: "Design System",
    rational: "Rational",
    couchbase: "Couchbase",
    couchbasemobile: "Couchbase Mobile",
    angular: "Angular",
    springboot: "Spring Boot",
    scrum: "SCRUM",
    cordova: "Cordova",
    yeoman: "Yeoman",
    git: "Git",
    swing: "Swing",
    gwt: "GWT",
    mdm: "MDM EBX 5",
    xsd: "XSD",
    wicket: "Wicket",
    ajax: "Ajax",
    docker: "Docker",
    gitlab: "Gitlab",
    cicd: "CI/CD",
    teamSpirit: "Team spirit",
    audacity: "Audacity",
    curiosity: "Curiosity",
    entrepeneurShip: "Entrepeneurship"
  }
};
